package dev.lingvo.site.components.marketing

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.selectors.hover
import dev.lingvo.site.ds.Radius
import dev.lingvo.site.ds.Space
import dev.lingvo.site.ds.toSitePalette
import dev.lingvo.site.ds.interactiveTransition
import dev.lingvo.site.ds.pressScale
import dev.lingvo.site.ds.pressTransition
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

val DocsWelcomeStyle = CssStyle {
    base { Modifier.fillMaxWidth().gap(Space.XL).styleModifier { property("display", "grid"); property("grid-template-columns", "minmax(0,1fr)") } }
    Breakpoint.MD { Modifier.styleModifier { property("grid-template-columns", "1.15fr 1fr") } }
}

val DocsWelcomeStartStyle = CssStyle.base {
    Modifier.fillMaxWidth().padding(Space.XXXL).backgroundColor(colorMode.toSitePalette().surfaceSunken)
        .borderRadius(Radius.Card).styleModifier { property("min-width", "0") }
}

val DocsWelcomeLinkStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().padding(Space.XL).gap(Space.MD)
            .border(1.px, LineStyle.Solid, colorMode.toSitePalette().border)
            .borderRadius(Radius.Card).color(colorMode.toSitePalette().accent).interactiveTransition()
            .styleModifier { property("display", "grid"); property("text-decoration", "none"); property("flex", "1") }
    }
    hover { Modifier.backgroundColor(colorMode.toSitePalette().surface) }
    cssRule(":active:not(:focus-visible)") { Modifier.pressScale().pressTransition() }
    focusVisible { Modifier.styleModifier { property("transition", "none"); property("outline", "2px solid ${colorMode.toSitePalette().accent}"); property("outline-offset", "3px") } }
}
